
import React, {useState, useEffect, useContext} from 'react';
import makeTitle from 'function/makeTitle.js';
import {SectionTitle,ListMedia} from 'components/items';
import {BtnIcon, BtnText} from 'components/btns';

import iconArrowLeft from 'image/ic_arrow_left.svg';
import iconArrowRight from 'image/ic_arrow_right.svg';

// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
import { authContext } from '../../shared/App';
var db = firebase.firestore();
const COLLECTION = "medias";

const sectionTitle = [
  {
    text: "MEDIA",
    color: "defualt",
    break: false
  },{
    text: "&",
    color: "main",
    break: false
  },{
    text: "PRESS",
    color: "default",
    break: false
  }
]

const Media = (props) => {
  const [mediaArr, setMediaArr] = useState([]);
  const [mediaCount, setMediaCount] = useState(0)
  const [styleList, setStyleList] = useState({});
  const [listWidth, setListWidth] = useState(25);
  const {setMediaLoading} = useContext(authContext);

  const _get = async () => {
    let arr = [];
    const ref = await db.collection(COLLECTION).orderBy('date', 'desc').limit(5).get();

    ref.forEach(doc => {
      arr.push({
        ...doc.data(),
        id: doc.id
      });
    })
    return arr;
  }

  useEffect(() => {
    const init = async () => {
      setMediaLoading(true);
      setMediaArr(await _get());
      setMediaLoading(false);
    }

    init();
    checkWindowWidth();
    window.addEventListener('resize', checkWindowWidth);
  }, [setMediaLoading])

  useEffect(()=> {
    setStyleList({
      width: `${mediaArr.length*listWidth}%`,
      left: `-${mediaCount*listWidth}%`
    })
  }, [mediaArr, mediaCount, listWidth]);

  const checkWindowWidth = () => {
    if(window.innerWidth<768){
      setListWidth(60);
    }else{
      setListWidth(25);
    }
  }

  const handleClickArrow = (e) => {
    if(e.target.classList[1] === "btn-arrowLeft"){
      if(mediaCount>0)
      setMediaCount(mediaCount-1);
    }else{
      if(mediaCount<mediaArr.length-4)
      setMediaCount(mediaCount+1);
    }
  }

  const drawMedia = () => {
    return mediaArr.map(el => {
      return <ListMedia el = {el} key={el.id}/>
    })
  }

  return (
    <section className={`Media ${props.className}`}>      
      <div className="section-header">
        <div className="con">
          <SectionTitle text = {makeTitle(sectionTitle)}  type = "center"/>
        </div>
      </div>
      <div className="section-contents">
        <div className="con">
          <div className="wrap-arrowBtns">
            <BtnIcon image = {iconArrowLeft} name = "iconArraowLeft" className = "btn-arrowLeft" onClick = {handleClickArrow}/>
            <BtnIcon image = {iconArrowRight} name = "iconArrowRight"  className = "btn-arrowRight" onClick = {handleClickArrow}/>
          </div>

          <div className="wrap-List">
            <ul className = "wrap-slidList" style = {styleList}>
              {drawMedia()}
            </ul>
          </div>
        </div>
        <BtnText to="/about/media" text = "모든 기사 보러가기" className="bgColor-main"/>
      </div>

    </section>
  );
}

export default Media;